
export const LigaUtils = {
    validateCreateUserLigaRequest (createUserLigaRequest) {
        if (createUserLigaRequest) {
            const keys = Object.getOwnPropertyNames(createUserLigaRequest)
            if (keys.indexOf('name') === -1) {
                throw new Error('Missing name attribute on answer object')
            }
        } else {
            throw new Error('no createUserLigaRequest object')
        }
    },

    validateDeleteUserLigaRequest (deleteUserLigaRequest) {
        if (deleteUserLigaRequest) {
            const keys = Object.getOwnPropertyNames(deleteUserLigaRequest)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on deleteUserLigaRequest object')
            }
        } else {
            throw new Error('no deleteUserLigaRequest object')
        }
    },

    validateJoinUserLigaRequest (joinUserLigaRequest) {
        if (joinUserLigaRequest) {
            const keys = Object.getOwnPropertyNames(joinUserLigaRequest)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on answer object')
            }
        } else {
            throw new Error('no joinUserLigaRequest object')
        }
    },

    validateGetAllLeaugeUsersRequest (getAllLeaugeUsersRequest) {
        if (getAllLeaugeUsersRequest) {
            const keys = Object.getOwnPropertyNames(getAllLeaugeUsersRequest)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on answer object')
            }
        } else {
            throw new Error('no getAllLeaugeUsersRequest object')
        }
    },

    validateRemoveUserFromLigaRequest (validateRemoveUserFromLigaRequest) {
        if (validateRemoveUserFromLigaRequest) {
            const keys = Object.getOwnPropertyNames(validateRemoveUserFromLigaRequest)
            if (keys.indexOf('ligaId') === -1) {
                throw new Error('Missing ligaId attribute on answer object')
            }
            if (keys.indexOf('userUid') === -1) {
                throw new Error('Missing userUid attribute on answer object')
            }
        } else {
            throw new Error('no validateRemoveUserFromLigaRequest object')
        }
    }
}
